import React, { useContext, useEffect, useState } from "react";
import FlipClockCountdown from "@leenguyen/react-flip-clock-countdown";
import "@leenguyen/react-flip-clock-countdown/dist/index.css";
import "./alert2.css";
import SmartoptLogo1 from "../../assets/image/smartoptLogo1.png";
import { baseUrl } from "../../config";
import TableContext from "../../Context/TablePosition";
import { NavLink, useLocation } from "react-router-dom";
import { ArrowLeftOutlined, ClockCircleFilled, InfoCircleFilled, WarningFilled } from '@ant-design/icons';
import { Button } from "antd";
import { useTranslation } from "react-i18next";

/**
 * Panel başlığı — koyu, yarı saydam kapsül; altındaki durum rengi (yeşil/sarı/turuncu)
 * ne olursa olsun okunur kalır.
 *
 * Not: `bg-black/55` gibi Tailwind'in opaklık ölçeğinde OLMAYAN bir durak
 * (geçerli duraklar: 0/5/10/20/25/30/40/50/60/70/75/80/90/95/100) JIT
 * tarafından sessizce üretilmiyor — sınıf hiç var olmuyor, panel tamamen
 * saydam kalıp yazı arkaplansız kalıyordu. Yalnız ölçekteki duraklar kullanılır.
 */
const PanelHeader = ({ icon, children }) => (
  <div className="mx-auto flex items-center gap-3 rounded-2xl bg-black/60 px-8 py-4 text-white shadow-xl backdrop-blur-sm">
    {icon}
    <span className="text-[52px] font-extrabold tracking-tight largeDesktop:text-[72px]">
      {children}
    </span>
  </div>
);

/** Etiket üstte / değer altta — Alert.js'teki `OrderField` ile aynı dil. */
const InfoChip = ({ label, value }) => (
  <div className="flex min-w-[220px] flex-col items-center gap-1 rounded-2xl border border-white/20 bg-black/40 px-8 py-4 text-white">
    <span className="text-[18px] font-bold uppercase tracking-[0.08em] opacity-70 largeDesktop:text-[22px]">{label}</span>
    <span className="text-[36px] font-extrabold largeDesktop:text-[46px]">{value || "—"}</span>
  </div>
);

const Alert2 = () => {
  const { t } = useTranslation();
  const [socket, setSocket] = useState(null);
  const [colorChangeTime, setColorChangeTime] = useState(null);
  const [plannedStopTime, setPlannedStopTime] = useState("");
  const [distanceColorChangeTime, setDistanceColorChangeTime] = useState(null);
  const [distancePlannedStopTime, setDistancePlannedStopTime] = useState(null);
  const [onTickRework, setOnTickRework] = useState({});
  const [onTickColor, setOnTickColor] = useState({});
  // const [isInFailure, setIsInFailure] = useState(false)
  const [second, setSecond] = useState(59);
  const [allData, setAllData] = useState("")
  const [allData1, setAllData1] = useState({})
  const [currentData, setCurrentData] = useState("")
  const [currentColor, setCurrentColor] = useState("")
  const { setCurrentUrl } = useContext(TableContext)
  const location = useLocation();

  useEffect(() => {
    localStorage.setItem("urlpaintshop", location.pathname)
    setCurrentUrl(localStorage.getItem("urlpaintshop"));
  }, [location.pathname, setCurrentUrl])

  useEffect(() => {
    const ws = new WebSocket(
      `${baseUrl}/ws/dashboard-socket-server/`
    );
    setSocket(ws);

    return () => {
      console.log("Alert2 socket closed");

      ws.close();
    };
  }, []);


  useEffect(() => {
    const handleOnline = () => {
      console.log("Yeniden Bağlanıyor...");
      const ws = new WebSocket(`${baseUrl}/ws/dashboard-socket-server/`);
      setSocket(ws);
    };

    const handleOffline = () => {
      console.log("Çevrimdışı - WebSocket bağlantısı kapatıldı.");
      if (socket) {
        socket.close();
      }

    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);

    };
  }, [socket]);

  useEffect(() => {
    let timer;

    if (socket) {
      socket.onopen = function (event) {
        console.log("Alarm2 Socket opened");
      };
      socket.onmessage = (e) => {
        let newData = JSON.parse(e.data);

        if (newData.type === "Color_Change_Time") {
          setAllData1(newData?.next_color)
          setCurrentColor(newData?.current_color)

        }
        if (newData.type === "Current_Situation") {
          setAllData(newData?.reason)
          setCurrentData(newData?.data)

        }


        if (newData.type === "Color_Change_Time") {
          // setPlannedStopTime(newData.data)
          setColorChangeTime(newData.data);
        }
        if (newData.type === "Rework_Time") {
          setPlannedStopTime(newData.data);
        }

      };

      timer = setInterval(() => {
        if (socket.readyState === WebSocket.OPEN) {
          console.log("send HealthCheck");
          socket.send(
            JSON.stringify({
              event_type: "HealthCheck",
            })
          );
        } else if (socket.readyState === WebSocket.CLOSED) {
          console.log("Socket is closed. Reopening...");
          const newSocket = new WebSocket(`${baseUrl}/ws/dashboard-socket-server/`);
          setSocket(newSocket);
        }
      }, 8000);
      return () => clearInterval(timer);
    }
  }, [socket]);

  useEffect(() => {
    if (colorChangeTime) {
      const currentDate = new Date();

      const [hours, minutes, seconds] = colorChangeTime.split(":");

      currentDate.setHours(hours);
      currentDate.setMinutes(minutes);
      currentDate.setSeconds(seconds);
      if (new Date().getTime() > currentDate.getTime()) {
        currentDate.setDate(currentDate.getDate() + 1);
      }
      setDistanceColorChangeTime(currentDate);
    }
    if (plannedStopTime) {
      // Şu anki tarih bilgisini al
      const currentDate = new Date();

      // "timeString"i saat, dakika ve saniye olarak ayır
      const [hours, minutes, seconds] = plannedStopTime.split(":");

      // "currentDate"i "timeString" saatine ayarla
      currentDate.setHours(hours);
      currentDate.setMinutes(minutes - 30);
      currentDate.setSeconds(seconds);
      if (new Date().getTime() > currentDate.getTime()) {
        currentDate.setDate(currentDate.getDate() + 1);
      }
      setDistancePlannedStopTime(currentDate);
    }
  }, [
    colorChangeTime,
    plannedStopTime,
    onTickColor.seconds,
    onTickRework.seconds,
  ]);

  useEffect(() => {
    let time;

    time = setInterval(() => {
      setSecond(second - 1);
    }, 1000);
    if (second === -1) {
      setSecond(59);
    }
    return () => clearInterval(time);
  }, [second]);

  return (
    <div className="relative flex h-full w-full flex-row">
      <Button className="absolute left-4 top-4 z-20 flex h-14 items-center gap-2 rounded-xl border-0 bg-black/60 px-5 text-base font-semibold text-white shadow-xl backdrop-blur-sm hover:bg-black/70 hover:text-white">
        <NavLink to="/asma" className="flex items-center gap-2 text-white">
          <ArrowLeftOutlined />
          {t("alert2.homePage")}
        </NavLink>
      </Button>

      <img
        className="absolute right-6 top-4 z-20 w-[180px] opacity-90"
        src={SmartoptLogo1}
        alt="Smartopt Logo"
      />

      {/* ---------- Sol panel: renk değişimi geri sayımı ---------- */}
      <div
        className="flex h-full w-full flex-col items-center gap-10 pt-24 transition-colors duration-300"
        style={
          onTickColor.days === 0 &&
            onTickColor.hours <= 1 &&
            onTickColor.hours >= 0 &&
            onTickColor.minutes < 7 &&
            onTickColor.minutes >= 0 &&
            onTickColor.seconds > 0
            ? second % 2 === 0
              ? { backgroundColor: "rgba(255,104,64)" }
              : null
            : null
        }
      >
        <PanelHeader icon={<ClockCircleFilled className="text-[40px] largeDesktop:text-[54px]" />}>
          {t("alert2.colorChange")}
        </PanelHeader>

        <div className="flex w-full flex-1 items-center justify-center">
          {distanceColorChangeTime && (
            <div className="flex flex-col items-center justify-center gap-10">
              <FlipClockCountdown
                to={distanceColorChangeTime}
                renderMap={[false, true, true, true]}
                className="flip-clock"
                labels={[t("alert2.day"), t("alert2.hour"), t("alert2.minute"), t("alert2.second")]}
                labelStyle={{ fontWeight: "bolder" }}
                onTick={(e) => setOnTickColor(e.timeDelta)}
              />

              <div className="flex flex-wrap justify-center gap-6">
                <InfoChip label={t("alert2.currentColor")} value={currentColor} />
                <InfoChip label={t("alert2.nextColor")} value={allData1} />
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="h-full w-[3px] shrink-0 bg-black/25" />

      {/* ---------- Sağ panel: sistem durumu ---------- */}
      <div
        className="flex h-full w-full flex-col items-center gap-10 pt-24 transition-colors duration-300"
        style={
          currentData === "Üretim" ? { backgroundColor: "green" } :
            currentData === "Duruş" ? { backgroundColor: "yellow" } :
              second % 2 === 0 ? { backgroundColor: "rgba(255,104,64)" } :
                { backgroundColor: "rgb(var(--surface))" }
        }
      >
        <PanelHeader icon={<InfoCircleFilled className="text-[40px] largeDesktop:text-[54px]" />}>
          {t("alert2.systemStatus")}
        </PanelHeader>

        {
          currentData === "Arıza" ?
            <div className="flex w-full flex-1 flex-col items-center justify-center gap-4 px-10">
              <div className="flex max-w-4xl flex-col items-center gap-4 rounded-3xl bg-black/50 px-16 py-12 text-center text-white shadow-xl backdrop-blur-sm">
                <WarningFilled className="text-[64px]" />
                <div className="text-[64px] font-extrabold leading-tight largeDesktop:text-[80px]">
                  {t("alert2.failureExists")}
                </div>
                <p className="text-[34px] font-semibold largeDesktop:text-[42px]">
                  {t("alert2.failureReason")}: {allData || ""}
                </p>
              </div>
            </div>
            :
            <div className="flex w-full flex-1 items-center justify-center px-10">
              <div className="rounded-3xl bg-black/40 px-20 py-14 text-center text-white shadow-xl backdrop-blur-sm">
                <div className="text-[64px] font-extrabold leading-tight largeDesktop:text-[84px]">
                  {allData}
                </div>
              </div>
            </div>
        }
      </div>
    </div>
  );
};

export default Alert2;
